export enum UserSignInOrganizationType {
  PreferredOrganization = 1,
  LastOrganization = 2,
}
